<template>
  <div id="app">
    <site-header></site-header>

    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  import SiteHeader from "@/components/site-header.vue"

  export default {
    name: "app",
    components: { SiteHeader }
  }
</script>
